export default "__VITE_ASSET__s0wbzBPA__"